import { ErrorMessageContents } from '../../helpers/hub'
import { SecuritySearchResult } from '../searchSecurities/types'
import { Security } from '../securities/reducer'
import { User } from '../users/types'
import { AdminWatchlist, WatchList, WatchlistDetails } from './types'

export const fetchWatchListsAction = (gridIndex: number) =>
  ({
    type: 'watchList.fetchWatchLists',
    payload: { gridIndex }
  } as const)
export type FetchWatchListsAction = ReturnType<typeof fetchWatchListsAction>

export const fetchWatchListsFailureAction = (
  gridIndex: number,
  error: ErrorMessageContents
) =>
  ({
    type: 'watchList.fetchWatchListsFailure',
    payload: { gridIndex, error },
    error: true
  } as const)
export type FetchWatchListsFailureAction = ReturnType<
  typeof fetchWatchListsFailureAction
>

export const fetchWatchListsSuccessAction = (
  gridIndex: number,
  watchlists: WatchList[]
) =>
  ({
    type: 'watchList.fetchWatchListsSuccess',
    payload: { gridIndex, watchlists }
  } as const)
export type FetchWatchListsSuccessAction = ReturnType<
  typeof fetchWatchListsSuccessAction
>

export const fetchAdminWatchListsAction = () =>
  ({
    type: 'watchList.fetchAdminWatchLists'
  } as const)
export type FetchAdminWatchListsAction = ReturnType<
  typeof fetchAdminWatchListsAction
>

export const fetchAdminWatchListsSuccessAction = (watchlists: WatchList[]) =>
  ({
    type: 'watchList.fetchAdminWatchListsSuccess',
    payload: { watchlists }
  } as const)
export type FetchAdminWatchListsSuccessAction = ReturnType<
  typeof fetchAdminWatchListsSuccessAction
>

export const fetchAdminWatchlistsByUserAction = (userId: User['id']) =>
  ({
    type: 'watchList.fetchAdminWatchlistsByUser',
    payload: userId
  } as const)
export type FetchAdminWatchlistsByUserAction = ReturnType<
  typeof fetchAdminWatchlistsByUserAction
>

export const fetchAdminWatchlistsByUserSuccessAction = (
  watchlists: WatchList[]
) =>
  ({
    type: 'watchList.fetchAdminWatchlistsByUserSuccess',
    payload: { watchlists }
  } as const)
export type FetchAdminWatchlistsByUserSuccessAction = ReturnType<
  typeof fetchAdminWatchlistsByUserSuccessAction
>

export const fetchAdminWatchlistsByIdentifierAction = (identifier: string) =>
  ({
    type: 'watchList.fetchAdminWatchlistsByIdentifier',
    payload: identifier
  } as const)
export type FetchAdminWatchlistsByIdentifierAction = ReturnType<
  typeof fetchAdminWatchlistsByIdentifierAction
>

export const fetchAdminWatchlistsByIdentifierSuccessAction = (
  watchlists: WatchList[]
) =>
  ({
    type: 'watchList.fetchAdminWatchlistsByIdentifierSuccess',
    payload: { watchlists }
  } as const)
export type FetchAdminWatchlistsByIdentifierSuccessAction = ReturnType<
  typeof fetchAdminWatchlistsByIdentifierSuccessAction
>

export const createWatchlistForUser = (watchlist: AdminWatchlist, userId = 0) =>
  ({
    type: `watchList.createWatchlistForUser`,
    payload: { watchlist, userId }
  } as const)
export type CreateWatchlistForUserAction = ReturnType<
  typeof createWatchlistForUser
>

export const addSecuritiesToWatchlist = (
  gridIndex: number,
  watchlistId: number,
  securityIds: Array<Security['id']>,
  identifiers: string[]
) =>
  ({
    type: 'watchList.addSecuritiesToWatchlist',
    payload: { gridIndex, watchlistId, securityIds, identifiers }
  } as const)
export type AddSecuritiesToWatchlistAction = ReturnType<
  typeof addSecuritiesToWatchlist
>

export const appendSecurityToWatchlist = (
  watchlistId: number,
  securityIds: Array<Security['id']>
) =>
  ({
    type: 'watchList.appendSecurityToWatchlist',
    payload: { watchlistId, securityIds }
  } as const)
export type AppendSecurityToWatchlistAction = ReturnType<
  typeof appendSecurityToWatchlist
>

export const appendIssuerToWatchlist = (
  watchlistId: number,
  issuer: Security['issuerSymbol'],
  append: boolean
) =>
  ({
    type: 'watchList.appendIssuerToWatchlist',
    payload: { watchlistId, issuer, append }
  } as const)
export type AppendIssuerToWatchlistAction = ReturnType<
  typeof appendIssuerToWatchlist
>

export const updateWatchlistDefinition = (watchlist: WatchList) =>
  ({
    type: 'watchList.updateWatchlistDefinition',
    payload: { watchlist }
  } as const)
export type UpdateWatchlistDefinitionAction = ReturnType<
  typeof updateWatchlistDefinition
>

export const watchlistDefinitionUpdated = (watchlist: WatchList) =>
  ({
    type: 'watchList.definitionUpdated',
    payload: watchlist
  } as const)
export type WatchlistDefinitionUpdatedAction = ReturnType<
  typeof watchlistDefinitionUpdated
>

export const failedSymbolsAndCusipsFromWatchlistDefinitionUpdate = (
  symbolsAndCusips: string[]
) => ({
  type: 'watchList.failedSymbolsAndCusipsFromWatchlistDefinitionUpdate' as const,
  payload: symbolsAndCusips
})
export type FailedSymbolsAndCusipsFromWatchlistDefinitionUpdate = ReturnType<
  typeof failedSymbolsAndCusipsFromWatchlistDefinitionUpdate
>

export const clearFailedSymbolsAndCusipsFromWatchlistDefinitionUpdate = () => ({
  type: 'watchList.clearFailedSymbolsAndCusipsFromWatchlistDefinitionUpdate' as const
})
export type ClearFailedSymbolsAndCusipsFromWatchlistDefinitionUpdate =
  ReturnType<typeof clearFailedSymbolsAndCusipsFromWatchlistDefinitionUpdate>

export const removeSecurityFromWatchlist = (
  watchlistId: number,
  securityId: number
) =>
  ({
    type: 'watchlist.removeSecurityFromWatchlist',
    payload: { watchlistId, securityId }
  } as const)
export type RemoveSecurityFromWatchlistAction = ReturnType<
  typeof removeSecurityFromWatchlist
>

export const removeCheckedSecuritiesFromWatchlist = (
  gridIndex: number,
  watchlistId: number
) =>
  ({
    type: 'watchlist.removeCheckedSecuritiesFromWatchlist',
    payload: { gridIndex, watchlistId }
  } as const)
export type RemoveCheckedSecuritiesFromWatchlistAction = ReturnType<
  typeof removeCheckedSecuritiesFromWatchlist
>

export const cancelAllWatchListOrdersAction = (watchlistId?: number) =>
  ({
    type: 'watchList.cancelAllWatchListOrdersAction',
    payload: { watchlistId }
  } as const)
export type CancelAllWatchListOrdersAction = ReturnType<
  typeof cancelAllWatchListOrdersAction
>

export const fetchWatchlistDetails = (watchlistId: number, gridIndex: number) =>
  ({
    type: 'watchList.fetchWatchlistDetails',
    payload: { watchlistId, gridIndex }
  } as const)
export type FetchWatchlistDetailsAction = ReturnType<
  typeof fetchWatchlistDetails
>

export const setWatchlistDetails = (watchlistId: number) =>
  ({
    type: 'watchList.setWatchlistDetails',
    payload: { watchlistId }
  } as const)
export type SetWatchlistDetailsAction = ReturnType<typeof setWatchlistDetails>

export const fetchWatchlistDetailsSuccess = (
  watchlistId: number,
  watchlistDetails: WatchlistDetails
) =>
  ({
    type: 'watchList.fetchWatchlistDetailsSuccess',
    payload: { watchlistId, watchlistDetails }
  } as const)
export type FetchWatchlistDetailsSuccessAction = ReturnType<
  typeof fetchWatchlistDetailsSuccess
>

export const fetchWatchlistDetailsFailure = (err: string) =>
  ({
    type: `watchList.fetchWatchlistDetailsFailure`,
    payload: err
  } as const)
export type FetchWatchlistDetailsFailureAction = ReturnType<
  typeof fetchWatchlistDetailsFailure
>

export const checkOrUncheckSecurities = (
  watchlistId: number,
  securityIds: number[],
  checked: boolean
) =>
  ({
    type: 'watchlist.checkOrUncheckSecurities',
    payload: { watchlistId, securityIds, checked }
  } as const)
export type CheckOrUncheckSecuritiesAction = ReturnType<
  typeof checkOrUncheckSecurities
>

export const resetCheckedSecurities = (watchlistId: number) =>
  ({
    type: 'watchlist.resetCheckedSecurities',
    payload: { watchlistId }
  } as const)
export type ResetCheckedSecuritiesAction = ReturnType<
  typeof resetCheckedSecurities
>

export const checkOrUncheckAllSecurities = (gridIndex: number) =>
  ({
    type: 'watchlist.checkOrUncheckAllSecurities',
    payload: { gridIndex }
  } as const)
export type CheckOrUncheckAllSecuritiesAction = ReturnType<
  typeof checkOrUncheckAllSecurities
>

export const setLastChecked = (watchlistId: number, securityId: number) =>
  ({
    type: 'watchlist.setLastChecked',
    payload: { watchlistId, securityId }
  } as const)
export type SetLastCheckedAction = ReturnType<typeof setLastChecked>

export const createNewWatchlist = (
  name: string,
  identifiers: string[],
  permission: string,
  book: string
) =>
  ({
    type: 'watchlist.createNewWatchlist',
    payload: { name, identifiers, permission, book }
  } as const)
export type CreateNewWatchlistAction = ReturnType<typeof createNewWatchlist>

export const deleteWatchlist = (watchlistId: number) =>
  ({
    type: 'watchlist.deleteWatchlist',
    payload: watchlistId
  } as const)
export type DeleteWatchlistAction = ReturnType<typeof deleteWatchlist>

export const deleteWatchlistSuccess = (watchlistId: number) => ({
  type: 'watchlist.deleteWatchlistSuccess' as const,
  payload: watchlistId
})
type DeleteWatchlistSuccessAction = ReturnType<typeof deleteWatchlistSuccess>

export const hideWatchlist = (watchlistId: number) =>
  ({
    type: 'watchlist.hideWatchlist',
    payload: watchlistId
  } as const)
export type HideWatchlistAction = ReturnType<typeof hideWatchlist>

export const updateWatchlistName = (watchlistId: number, newName: string) =>
  ({
    type: 'watchList.updateWatchlistName',
    payload: { watchlistId, newName }
  } as const)
export type UpdateWatchlistNameAction = ReturnType<typeof updateWatchlistName>

export const fetchBackgroundDetails = () =>
  ({
    type: `watchList.fetchBackgroundDetails`
  } as const)
export type FetchBackgroundDetailsAction = ReturnType<
  typeof fetchBackgroundDetails
>

export const fetchBackgroundDetailsSuccess = (
  details: SecuritySearchResult[]
) =>
  ({
    type: `watchList.fetchBackgroundDetailsSuccess`,
    payload: details
  } as const)
export type FetchBackgroundDetailsSuccessAction = ReturnType<
  typeof fetchBackgroundDetailsSuccess
>

export type WatchListsAction =
  | FetchWatchListsAction
  | FetchWatchListsFailureAction
  | FetchWatchListsSuccessAction
  | CancelAllWatchListOrdersAction
  | FetchWatchlistDetailsAction
  | FetchWatchlistDetailsSuccessAction
  | FetchWatchlistDetailsFailureAction
  | CheckOrUncheckSecuritiesAction
  | SetWatchlistDetailsAction
  | ResetCheckedSecuritiesAction
  | CheckOrUncheckAllSecuritiesAction
  | CreateNewWatchlistAction
  | DeleteWatchlistAction
  | DeleteWatchlistSuccessAction
  | HideWatchlistAction
  | AppendIssuerToWatchlistAction
  | AppendSecurityToWatchlistAction
  | UpdateWatchlistDefinitionAction
  | FailedSymbolsAndCusipsFromWatchlistDefinitionUpdate
  | ClearFailedSymbolsAndCusipsFromWatchlistDefinitionUpdate
  | UpdateWatchlistNameAction
  | SetLastCheckedAction
  | FetchAdminWatchListsAction
  | FetchAdminWatchListsSuccessAction
  | FetchAdminWatchlistsByUserAction
  | FetchAdminWatchlistsByUserSuccessAction
  | FetchAdminWatchlistsByIdentifierAction
  | FetchAdminWatchlistsByIdentifierSuccessAction
  | CreateWatchlistForUserAction
  | WatchlistDefinitionUpdatedAction
  | FetchBackgroundDetailsSuccessAction
  | RemoveCheckedSecuritiesFromWatchlistAction
  | RemoveSecurityFromWatchlistAction
  | AddSecuritiesToWatchlistAction
